import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { compareVersions, getCurrentAppVersion } from '@helpers/compare-versions';
import { getPermissionIfExists } from '@helpers/permissions';
import { CarnivitaPmsService } from '@services/carnivita-pms/carnivita-pms.service';
import { AppVersionsService } from '@services/home/app-versions/app-versions.service';

declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private appVersionsService: AppVersionsService,
    private carnivitaService: CarnivitaPmsService
  ) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-VE96YZWR72', { 'page_path': event.urlAfterRedirects });
      }
    })
  }

  ngOnInit(): void {
    // if (isPermissionExist('DoctorGliptus')) {
    //   this.router.navigate(['/gliptus-pms']);
    // }
    if (getPermissionIfExists('DoctorCarnivita')) {
      this.carnivitaService.getCarnivitaConfigurations().subscribe((res) => {
        let carnivitaConfiguration = res.data;
        localStorage.setItem('carnivitaConfigurations', JSON.stringify(carnivitaConfiguration))
      })
      // this.router.navigate(['/carnivita-pms']);
    }
    this.appVersionsService.getAppVersions().subscribe(res => {
      let currentAppVersion: string = getCurrentAppVersion(res.data.patientVersionApp);
      let savedAppVersion = localStorage.getItem('appVersion');
      if (compareVersions(currentAppVersion, savedAppVersion || '0.0.0') > 0) {
        localStorage.setItem('appVersion', currentAppVersion);
      }
    });
  }
}
